import { Content } from "./components";

const LandingLayout = {
  Content,
};

export default LandingLayout;
